<!-- Footer -->
<span>{{ appName }} v-{{ version }}</span>
<!-- Footer -->
